import React, { useState, useEffect, useRef } from "react";
import {
  AGENCY_ADMIN,
  AGENCY_EMPLOYEE,
} from "../../../constants/HelperConstants";
import {
  EMPLOYEE_LIST,
  DELETE_USER,
  GET_SINGLE_USER,
  DECRYPT_PASSWORD_URL,
} from "../../../constants/ApiPaths";
import Swal from "sweetalert2";
import { authHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  Badge,
  UncontrolledCollapse,
  Input,
  CardBody,
  Tooltip,
} from "reactstrap";
import AgencyModal from "./AgencyModal";
import Pagination from "react-js-pagination";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import { debounce } from "underscore";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import {
  getAgencyId,
  getAdminUserId,
  getRootUser,
} from "../../common/CommonFunctions";
import defaultAvatar from "../../../constants/Images/defaultAvatar-1.png";
import { Info } from "../../common/Info";
import { useSelector } from "react-redux";

// Id
const Id = getAdminUserId();

const roleType = {
  [AGENCY_ADMIN]: "Admin",
  [AGENCY_EMPLOYEE]: "Employee",
};

// intial Values
const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  gender: "",
  dateOfBirth: "",
  phoneNumber: "+1 ",
  profileImage: "",
  stateId: "",
  city: "",
  address: "",
  zip: "",
  createdBy: Id,
  agencyId: getAgencyId(),
  roleId: "",
  hyperlink: window.location.origin,
};

//Main function Component
function AgencyEmployee(props) {
  const { className } = props;
  const [modal, setModal] = useState(false);
  const [formData, setFormData] = useState(initialValues);
  const [loading, setLoading] = useState(false);
  const [Count, setCount] = useState(1);
  const [flag, setflag] = useState(true);
  const [details, setDetails] = useState([]);
  let rowperpage=9
  const [currentpage, setCurrentPage] = useState(0);
  const [totalrecords, setTotalRecords] = useState(0);
  const [emailDisabled, setEmailDisabled] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [searchName, setName] = useState("");
  const [searchEmail, setEmail] = useState("");
  const [searchPhoneNumber, setPhoneNumber] = useState("+1 ");
  const { enqueueSnackbar } = useSnackbar();
  let ID=getAdminUserId()
  let RootUser=getRootUser()
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const Delete = useSelector((state) => state.Agencydelete);
  const [passwordhide, setPasswordHide] = useState(details.map(() => true));
  const [oldPassword, setOldpassword] = useState();
  const togglePasswordVisibility = (index) => {
    const newPasswordHide = [...passwordhide];
    newPasswordHide[index] = !newPasswordHide[index];
    setPasswordHide(newPasswordHide);
  };
  const hideFun = async (userId, password, index) => {
    togglePasswordVisibility(index);
  };
  const tooltiptoggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  //reset Form Data
  let resetFormData = () => {
    setFormData({
      firstName: "",
      email: "",
      lastName: "",
      phoneNumber: "+1 ",
      roleId: "",
      city: "",
      hyperlink: window.location.origin,
      stateId: "",
      address: "",
      gender: "",
      createdBy: Id,
      dateOfBirth: "",
      profileImage: "",
      agencyId: getAgencyId(),
      zip: "",
    });
  };

  //toggle form
  const toggle = () => {
    if (Delete) {
      return;
    }
    setModal(!modal);
    setflag(true);
    resetFormData();
  };
  const copyPasswordFun = async (pass) => {
    // let password = "Apptomate@123";
    try {
      await navigator.clipboard.writeText(pass);
      CustomAlertMessage(
        "Password copied to clipboard",
        "success",
        enqueueSnackbar
      );
    } catch (err) {
      CustomAlertMessage(
        "Unable to copy password to clipboard",
        "error",
        enqueueSnackbar
      );
    }
  };
  const getDecrypted = async (password) => {
    const config = {
      method: "POST",
      headers: authHeader(),
      url: DECRYPT_PASSWORD_URL,
      data: {
        encrypt: password,
      },
    };
    try {
      const response = await API(config);
      if (response) {
        console.log("success", response);
        // ps = response.data;
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  };
  const decryptPasswords = async (data) => {
    try {
      const decryptedData = await Promise.all(
        data.map(async (item) => {
          const decryptedPassword = await getDecrypted(item.password);
          return { ...item, password: decryptedPassword };
        })
      );

      return decryptedData;
    } catch (error) {
      console.error(error);
      // Handle error if needed
    }
  };
  // employee details
  let EmployeeDetails = async (searchName, searchEmail, searchPhoneNumber) => {
    setPageLoading(true);
    const config = {
      method: "GET",
      url: EMPLOYEE_LIST,
      headers: authHeader(),
      params: {
        roleId: [3, 4],
        agencyId: getAgencyId(),
        offset: currentpage,
        count: rowperpage,
        firstName: searchName,
        email: searchEmail,
        phoneNumber: searchPhoneNumber
          ? searchPhoneNumber.includes("+1")
            ? searchPhoneNumber.split("+1 ")[1]
            : searchPhoneNumber
          : "",
      },
    };
    try {
      const response = await API(config);
      const { status, data, totalCount } = response.data;
      if (status === "Success") {
        const d1 = data && (await decryptPasswords(data));
        setDetails(d1);
        setPasswordHide(d1.map(() => true));
        setLoading(false);
        setTotalRecords(totalCount);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setPageLoading(false);
    }
  };

  // pagechange
  const onPageChange = (page) => {
    setCurrentPage(page - 1);
  };

  //Profile image
  let Profile = (i) => {
    const image = i.profileImage;
    if (image) {
      return image;
    } else {
      return defaultAvatar;
    }
  };

  //update user
  let UpdateUser = async (e) => {
    if (Delete) {
      return;
    }
    setModal(!modal);
    setflag(false);
    setEmailDisabled(true);
    setLoading(true);
    const ID = e.currentTarget.dataset.userid;
    const config = {
      method: "GET",
      url: GET_SINGLE_USER,
      headers: authHeader(),
      params: {
        userId: ID,
      },
    };
    try {
      const response = await API(config);
      const { status, data } = response.data;
      if (status === "Success") {
        const decryptedPassword = await getDecrypted(data.password);
        data.password = decryptedPassword;
        setOldpassword(data.password);
        console.log("data", data);
        setFormData({ ...data, phoneNumber: "+1 ".concat(data.phoneNumber) });
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setEmailDisabled(false);
      setLoading(false);
    }
  };

  // Delete User
  let DeleteEmployee = async (ID) => {
    const config = {
      method: "DELETE",
      url: DELETE_USER,
      headers: authHeader(),
      params: {
        userId: ID,
      },
    };
    try {
      const response = await API(config);
      const { status } = response.data;
      if (status === "Success") {
        setCount(Count + 1);
        CustomAlertMessage("Deleted Succesfully", "success", enqueueSnackbar);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
    }
  };

  // Delete User UI
  function DeleteDetails(e) {
    if (Delete) {
      return;
    }
    const ID = e.currentTarget.dataset.userid;
    Swal.fire({
      title: "Are you sure?",
      text: "Are You Want to Delete this Employee!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        DeleteEmployee(ID);
      }
    });
  }

  //logout functionality
 

  const onHandleNameChange = (e) => {
    const { value } = e.target;
    setName(value);
  };

  const onHandleEmailChange = (e) => {
    const { value } = e.target;
    setEmail(value);
  };

  const onHandlePhoneChange = (e) => {
    const { value } = e.target;
    const numericValue = e.target.value.replace(/[^0-9+\s]/g, "");
    console.log("ph no", value, e);

    setPhoneNumber(numericValue);
  };

  const clearButton = () => {
    setName("");
    setEmail("");
    setPhoneNumber("");
  };

  const delaySearch = useRef(
    debounce((searchName, searchEmail, searchPhoneNumber) =>
      EmployeeDetails(searchName, searchEmail, searchPhoneNumber)
    )
  ).current;

  useEffect(() => {
    delaySearch(searchName, searchEmail, searchPhoneNumber);
  }, [searchName, searchEmail, searchPhoneNumber]);

  useEffect(() => {
    console.log("called employee page");

    EmployeeDetails();
  }, [Count, currentpage, rowperpage]);

  return (
    <div>
      <div className="agency-wrapper">
        <Container fluid>
          <div className="page-title">
            <h4>
              Employee{" "}
              <Tooltip
                isOpen={id === "employee" && tooltipOpen}
                target={"employee"}
                toggle={() => tooltiptoggle("employee")}
              >
                View employee information details
              </Tooltip>
              <span id={"employee"}>
                <Info />
              </span>{" "}
            </h4>

            <div className="top-btn">
              <Button color="link" id="toggler">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14.371"
                  height="14.371"
                  viewBox="0 0 14.371 14.371"
                >
                  <path
                    id="Icon_awesome-filter"
                    data-name="Icon awesome-filter"
                    d="M13.7,0H.674A.674.674,0,0,0,.2,1.15L5.389,6.342v5.784a.674.674,0,0,0,.287.552l2.246,1.571a.674.674,0,0,0,1.06-.552V6.342L14.173,1.15A.674.674,0,0,0,13.7,0Z"
                    fill="#1b3e6f"
                  />
                </svg>
              </Button>

              <Button
                disabled={Delete}
                onClick={() => toggle(resetFormData)}
                color="primary"
              >
                <svg
                  className="mr-3"
                  xmlns="http://www.w3.org/2000/svg"
                  width="12.401"
                  height="12.402"
                  viewBox="0 0 12.401 12.402"
                >
                  <g
                    id="Icon_feather-plus"
                    data-name="Icon feather-plus"
                    transform="translate(-6.6 -6.6)"
                  >
                    <path
                      id="Path_82"
                      data-name="Path 82"
                      d="M18,7.5V18.1"
                      transform="translate(-5.199)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.8"
                    />
                    <path
                      id="Path_83"
                      data-name="Path 83"
                      d="M7.5,18H18.1"
                      transform="translate(0 -5.199)"
                      fill="none"
                      stroke="#fff"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="1.8"
                    />
                  </g>
                </svg>
                Create New Employee
              </Button>
            </div>
          </div>

          {/* filter */}
          <UncontrolledCollapse toggler="#toggler" className="mt-4">
            <Card>
              <CardBody>
                <Row>
                  <Col md="3">
                    <Input
                      type="text"
                      name="name"
                      value={searchName}
                      onChange={onHandleNameChange}
                      placeholder="Search Name"
                    />
                  </Col>
                  <Col md="3">
                    <Input
                      type="email"
                      name="Email"
                      value={searchEmail}
                      onChange={onHandleEmailChange}
                      placeholder="Search Email"
                    />
                  </Col>
                  <Col md="3">
                    <Input
                      type="text"
                      name="phoneNumber"
                      value={searchPhoneNumber}
                      onChange={onHandlePhoneChange}
                      placeholder="Search PhoneNumber"
                    />
                  </Col>
                  <Col md="3">
                    <Button
                      color="danger"
                      size="sm"
                      className="mt-2"
                      onClick={clearButton}
                    >
                      Clear
                    </Button>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </UncontrolledCollapse>

          <Card body className="mt-4">
            {pageLoading ? <CustomPageLoading /> : ""}
            <Row>
              {pageLoading ? (
                ""
              ) : details.length === 0 ? (
                <center>No Records Found</center>
              ) : (
                details.map((data, index) => (
                  <Col key={data.id} md="6" lg="6" xl="4">
                    <div className="employee-box">
                      <img src={Profile(data)} alt=""/>
                      <h5>
                        {data.firstName}
                        {data.lastName}
                      </h5>
                      <Badge color="primary">{roleType[data.roleName]}</Badge>
                      <div className="action-btn">
                        {RootUser === "true" ? (
                          <Button
                            className="editBtn"
                            color="link"
                            disabled={Delete}
                            data-userid={data.userId}
                            onClick={UpdateUser}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10.928"
                              height="10.928"
                              viewBox="0 0 10.928 10.928"
                            >
                              <path
                                id="Icon_material-mode-edit"
                                data-name="Icon material-mode-edit"
                                d="M4.5,13.148v2.276H6.776L13.49,8.711,11.214,6.434Zm10.75-6.2a.6.6,0,0,0,0-.856l-1.42-1.42a.6.6,0,0,0-.856,0L11.863,5.785,14.14,8.061,15.25,6.95Z"
                                transform="translate(-4.5 -4.496)"
                                fill="#fff"
                              />
                            </svg>
                          </Button>
                        ) : parseInt(data.userId) === parseInt(ID) ? (
                          <Button
                            className="editBtn"
                            color="link"
                            disabled={Delete}
                            data-userid={data.userId}
                            onClick={UpdateUser}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10.928"
                              height="10.928"
                              viewBox="0 0 10.928 10.928"
                            >
                              <path
                                id="Icon_material-mode-edit"
                                data-name="Icon material-mode-edit"
                                d="M4.5,13.148v2.276H6.776L13.49,8.711,11.214,6.434Zm10.75-6.2a.6.6,0,0,0,0-.856l-1.42-1.42a.6.6,0,0,0-.856,0L11.863,5.785,14.14,8.061,15.25,6.95Z"
                                transform="translate(-4.5 -4.496)"
                                fill="#fff"
                              />
                            </svg>
                          </Button>
                        ) : (
                          <Button
                            className="editBtn"
                            color="link"
                            data-userid={data.userId}
                            onClick={UpdateUser}
                            disabled={Delete && true}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10.928"
                              height="10.928"
                              viewBox="0 0 10.928 10.928"
                            >
                              <path
                                id="Icon_material-mode-edit"
                                data-name="Icon material-mode-edit"
                                d="M4.5,13.148v2.276H6.776L13.49,8.711,11.214,6.434Zm10.75-6.2a.6.6,0,0,0,0-.856l-1.42-1.42a.6.6,0,0,0-.856,0L11.863,5.785,14.14,8.061,15.25,6.95Z"
                                transform="translate(-4.5 -4.496)"
                                fill="#fff"
                              />
                            </svg>
                          </Button>
                        )}
                        {RootUser ? (
                          <Button
                            onClick={DeleteDetails}
                            data-userid={data.userId}
                            data-rolename={data.roleName}
                            className="deleteBtn"
                            color="link"
                            disabled={
                              Delete ||
                              Boolean(parseInt(data.userId) === parseInt(ID))
                            }
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10.236"
                              height="13.161"
                              viewBox="0 0 10.236 13.161"
                            >
                              <path
                                id="Icon_material-delete"
                                data-name="Icon material-delete"
                                d="M8.231,16.2a1.467,1.467,0,0,0,1.462,1.462h5.849A1.467,1.467,0,0,0,17.005,16.2V7.425H8.231ZM17.736,5.231H15.177L14.446,4.5H10.79l-.731.731H7.5V6.693H17.736Z"
                                transform="translate(-7.5 -4.5)"
                                fill="#fff"
                              />
                            </svg>
                          </Button>
                        ) : parseInt(data.userId) === parseInt(ID) ? (
                          <Button
                            onClick={DeleteDetails}
                            data-userid={data.userId}
                            data-rolename={data.roleName}
                            className="deleteBtn"
                            color="link"
                            disabled={Delete}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10.236"
                              height="13.161"
                              viewBox="0 0 10.236 13.161"
                            >
                              <path
                                id="Icon_material-delete"
                                data-name="Icon material-delete"
                                d="M8.231,16.2a1.467,1.467,0,0,0,1.462,1.462h5.849A1.467,1.467,0,0,0,17.005,16.2V7.425H8.231ZM17.736,5.231H15.177L14.446,4.5H10.79l-.731.731H7.5V6.693H17.736Z"
                                transform="translate(-7.5 -4.5)"
                                fill="#fff"
                              />
                            </svg>
                          </Button>
                        ) : (
                          <Button
                            onClick={DeleteDetails}
                            data-userid={data.userId}
                            data-rolename={data.roleName}
                            className="deleteBtn"
                            color="link"
                            disabled={Delete}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10.236"
                              height="13.161"
                              viewBox="0 0 10.236 13.161"
                            >
                              <path
                                id="Icon_material-delete"
                                data-name="Icon material-delete"
                                d="M8.231,16.2a1.467,1.467,0,0,0,1.462,1.462h5.849A1.467,1.467,0,0,0,17.005,16.2V7.425H8.231ZM17.736,5.231H15.177L14.446,4.5H10.79l-.731.731H7.5V6.693H17.736Z"
                                transform="translate(-7.5 -4.5)"
                                fill="#fff"
                              />
                            </svg>
                          </Button>
                        )}
                      </div>

                      <div className="list-group list-group-flush list-group-no-gutters mt-4">
                        <div className="list-group-item">
                          <div className="row align-items-center">
                            <div className="col">
                              <small className="card-subtitle">
                                Full Name :
                              </small>
                            </div>

                            <div className="col-auto">
                              <p>
                                {data.firstName}
                                {data.lastName}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="list-group-item">
                          <div className="row align-items-center">
                            <div className="col">
                              <small className="card-subtitle">Mobile :</small>
                            </div>

                            <div className="col-auto">
                              <p>
                                {" "}
                                {data.phoneNumber
                                  ? `+1 ${data.phoneNumber}`
                                  : ""}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="list-group-item">
                          <div className="row align-items-center">
                            <div className="col">
                              <small className="card-subtitle">Email :</small>
                            </div>

                            <div className="col-auto">
                              <p>{data.email}</p>
                            </div>
                          </div>
                        </div>
                        <div className="list-group-item">
                          <div className="row align-items-center">
                            <div className="col">
                              <small className="card-subtitle">
                                Password :
                              </small>
                            </div>
                            <div className="col-auto">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <p style={{ paddingTop: "3px" }}>
                                  {passwordhide[index] === true && data.password
                                    ? "*".repeat(data.password.length)
                                    : data.password}
                                  {/* {renderPassword(i.userId, i.password)} */}
                                </p>
                                <Button
                                  onClick={() => {
                                    copyPasswordFun(data.password);
                                  }}
                                  className="btn-secondary-cr pass-btn"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                  >
                                    <path
                                      d="M14.0125 3.28125H7.78125C7.36685 3.28125 6.96942 3.44587 6.6764 3.7389C6.38337 4.03192 6.21875 4.42935 6.21875 4.84375V13.375C6.21875 13.7894 6.38337 14.1868 6.6764 14.4799C6.96942 14.7729 7.36685 14.9375 7.78125 14.9375H14.0125C14.4269 14.9375 14.8243 14.7729 15.1174 14.4799C15.4104 14.1868 15.575 13.7894 15.575 13.375V4.83125C15.5717 4.41902 15.4056 4.02479 15.113 3.73447C14.8203 3.44414 14.4247 3.28124 14.0125 3.28125ZM14.6375 13.375C14.6375 13.5408 14.5717 13.6997 14.4544 13.8169C14.3372 13.9342 14.1783 14 14.0125 14H7.78125C7.61549 14 7.45652 13.9342 7.33931 13.8169C7.2221 13.6997 7.15625 13.5408 7.15625 13.375V4.83125C7.15625 4.66549 7.2221 4.50652 7.33931 4.38931C7.45652 4.2721 7.61549 4.20625 7.78125 4.20625H14.0125C14.1783 4.20625 14.3372 4.2721 14.4544 4.38931C14.5717 4.50652 14.6375 4.66549 14.6375 4.83125V13.375Z"
                                      fill="#3D3D3D"
                                    />
                                    <path
                                      d="M12.2093 15.7813H5.99365C5.82789 15.7813 5.66892 15.7154 5.55171 15.5982C5.4345 15.481 5.36865 15.322 5.36865 15.1563V6.6344C5.36865 6.51008 5.31927 6.39085 5.23136 6.30294C5.14345 6.21504 5.02422 6.16565 4.8999 6.16565C4.77558 6.16565 4.65635 6.21504 4.56845 6.30294C4.48054 6.39085 4.43115 6.51008 4.43115 6.6344V15.1594C4.43115 15.5738 4.59577 15.9712 4.8888 16.2643C5.18182 16.5573 5.57925 16.7219 5.99365 16.7219H12.2093C12.334 16.7219 12.4536 16.6723 12.5418 16.5841C12.63 16.4959 12.6796 16.3763 12.6796 16.2516C12.6796 16.1269 12.63 16.0072 12.5418 15.919C12.4536 15.8308 12.334 15.7813 12.2093 15.7813Z"
                                      fill="#3D3D3D"
                                    />
                                  </svg>
                                </Button>
                                <Button
                                  data={data.userId}
                                  onClick={() =>
                                    hideFun(data.userId, data.password, index)
                                  }
                                  className="btn-secondary-cr"
                                >
                                  {passwordhide[index] === true ? (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                    >
                                      <path
                                        d="M12.1082 7.89172L7.8916 12.1084C7.34994 11.5667 7.0166 10.825 7.0166 10C7.0166 8.35002 8.3499 7.01672 9.9999 7.01672C10.8249 7.01672 11.5666 7.35006 12.1082 7.89172Z"
                                        stroke="#3D3D3D"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M14.8499 4.80834C13.3916 3.70834 11.7249 3.10834 9.99989 3.10834C7.0582 3.10834 4.31654 4.84167 2.4082 7.84167C1.6582 9.01669 1.6582 10.9917 2.4082 12.1667C3.06654 13.2 3.8332 14.0917 4.66654 14.8084"
                                        stroke="#3D3D3D"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M7.0166 16.2751C7.9666 16.6751 8.9749 16.8918 9.9999 16.8918C12.9416 16.8918 15.6832 15.1584 17.5916 12.1584C18.3416 10.9834 18.3416 9.00844 17.5916 7.8334C17.3166 7.40007 17.0166 6.99173 16.7082 6.6084"
                                        stroke="#3D3D3D"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M12.925 10.5833C12.7083 11.7583 11.75 12.7166 10.575 12.9333"
                                        stroke="#3D3D3D"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M7.89175 12.1083L1.66675 18.3333"
                                        stroke="#3D3D3D"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M18.3334 1.66669L12.1084 7.89169"
                                        stroke="#3D3D3D"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  ) : (
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                    >
                                      <path
                                        d="M12.9833 10.0001C12.9833 11.6501 11.6499 12.9834 9.99993 12.9834C8.34993 12.9834 7.0166 11.6501 7.0166 10.0001C7.0166 8.35006 8.34993 7.01672 9.99993 7.01672C11.6499 7.01672 12.9833 8.35006 12.9833 10.0001Z"
                                        stroke="#3D3D3D"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M10.0001 16.8916C12.9418 16.8916 15.6834 15.1583 17.5918 12.1583C18.3418 10.9833 18.3418 9.00831 17.5918 7.83331C15.6834 4.83331 12.9418 3.09998 10.0001 3.09998C7.05845 3.09998 4.31678 4.83331 2.40845 7.83331C1.65845 9.00831 1.65845 10.9833 2.40845 12.1583C4.31678 15.1583 7.05845 16.8916 10.0001 16.8916Z"
                                        stroke="#3D3D3D"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                  )}
                                </Button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="list-group-item">
                          <div className="row align-items-center">
                            <div className="col">
                              <small className="card-subtitle">
                                Location :
                              </small>
                            </div>

                            <div className="col-auto">
                              <p>{data.stateName}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))
              )}
            </Row>
          </Card>
          <div className="d-flex flex-row py-4 justify-content-end">
            <Pagination
              itemClass="page-item"
              linkClass="page-link"
              itemsCountPerPage={rowperpage}
              totalItemsCount={totalrecords}
              activePage={currentpage + 1}
              onChange={onPageChange}
            />
          </div>
        </Container>
      </div>
      <AgencyModal
        modal={modal}
        toggleHelper={toggle}
        className={className}
        flag={flag}
        setflag={setflag}
        formData={formData}
        oldPassword={oldPassword}
        setFormData={setFormData}
        Count={Count}
        setCount={setCount}
        resetFormData={resetFormData}
        emailDisabled={emailDisabled}
        loading={loading}
        setLoading={setLoading}
        enqueueSnackbar={enqueueSnackbar}
      />
    </div>
  );
}

export default AgencyEmployee;
